import gql from 'graphql-tag';

export default gql`
  query FetchUserFlagQuery($identifier: UserFlagIdentifierType!) {
    me {
      id
      flags {
        getOne(identifier: $identifier) {
          identifier
        }
      }
    }
  }
`;
